import { Box, Center, Spinner, Text } from '@chakra-ui/react';
import useQueryParam from 'hooks/shared/useQueryParam';
import PrivateChannelArticleListItem from 'presentation/components/modules/articles/PrivateChannelArticleListItem';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import PaginationContentWrap from 'presentation/components/shared/pagination/PaginationContentWrap';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchPrivateChannelArticlesQuery } from 'rtkQuery/sharespro/queries/articles';

const PrivateChannelListContainer: FC = () => {
  const { t } = useTranslation();

  const [page, setPage] = useQueryParam<number>('page', {
    ifAbsent: 1,
    provider: (val) => parseInt(val),
  });
  const { data, isFetching, error, refetch } =
    useFetchPrivateChannelArticlesQuery({ page });
  let wrapByCard = true;
  let content;
  if (data) {
    if (data.items.length > 0) {
      content = (
        <PaginationContentWrap
          itemsCount={data.itemsCount}
          isFetching={isFetching}
          setPage={setPage}
          currentPage={data.currentPage}
          pageCount={data.pageCount}
        >
          {data.items.map((article, index) => {
            let color: string;
            if (index % 3 === 2) {
              color = '#210061';
            } else if (index % 3 === 1) {
              color = '#393939';
            } else {
              color = '#26925f';
            }

            return (
              <Box mb="20px" key={article.id}>
                <PrivateChannelArticleListItem
                  article={article}
                  color={color}
                  page={data.currentPage}
                />
              </Box>
            );
          })}
        </PaginationContentWrap>
      );
      wrapByCard = false;
    } else {
      content = <Text textAlign="center">{t('listIsEmpty')}</Text>;
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }
  if (wrapByCard) {
    content = (
      <AppCard p="20">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return content;
};

export default PrivateChannelListContainer;
